import {
    formatterDateToUTC
} from "@/util/util";

export const distributionEngineerFormOption = {
    submitBtn: false,
    emptyBtn: false,
    addBtn: false,
    menu: false,
    columnBtn: false,
    refreshBtn: false,
    searchBtn: false,
    header: false,
    width: "50%",
    border: true,
    // cellBtn:false,
    //viewBtn: true,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        //dispaly 不起作用,只能判断订单状态,打开不同的option配置
        {
            label: "商品名称",
            type: "input",
            span: 13,
            prop: "goodsName"
        },
        {
            label: "价格",
            span: 13,
            type: "input",
            prop: "goodsPrice"
        },
        {
            label: "单位",
            span: 13,
            type: "input",
            prop: "unit"
        },
        {
            label: "数量",
            span: 13,
            type: "input",
            prop: "goodsNum"
        },
    ]
};